<span
  class="badge rounded-pill status-pill"
  [class.status-pill-complete]="category === 'complete'"
  [class.status-pill-in-progress]="category === 'in-progress'"
  [class.status-pill-updated]="category === 'updated'"
  ><strong>{{ label }}</strong></span
>
